import React, {CSSProperties} from "react";
import styled from "styled-components";

export default function Input(props: {
    value: string
    onChange: (val: string) => void
    style?: CSSProperties
    className?: string
    placeholder?: string
}) {
    return <XInput placeholder={props.placeholder} className={props.className} value={props.value} onChange={e => props.onChange(e.target.value)} style={props.style}/>
}

const XInput = styled.input`
  width: 377px;
  height: 45px;
  border-radius: 9px;
  background: #FFF;
  padding: 12px;
  font-size: 14px;
  &::placeholder {
    color: #B3B3B3;
  }
`